import React, { useCallback, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import TextBlock from '../form/blocks/TextBlock';
import GetAddress from '../form/blocks/GetAddress';
import DropdownBlock from '../form/blocks/DropdownBlock';
import axios from 'axios';
import { config } from '../../utils/config'
// import AuthContext from '../authcontext/AuthContext';
import CommonModal from './CommonModal';

export default function BiddingRegistration(props) {

    // const authData = useContext(AuthContext)

    const [show, setShow] = useState(false);
    const [termsModal, setTermsModal] = useState(false)
    const [exisitingClient, setExistingClient] = useState("")
    const [nric, setNric] = useState("");
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [floor, setFloor] = useState("");
    const [unit, setUnit] = useState("");
    const [residentStatus, setResidentStatus] = useState("");
    const [country, setCountry] = useState("");
    const [mobile, setMobile] = useState("");
    const [options] = useState([{
        residentStatus: ["", "Singapore Citizen", "Singapore PR", "Foreigner"]
    }])
    const [nricError, setNricError] = useState("");
    const [nameError, setNameError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [residentError, setResidentError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [mobileError, setMobileError] = useState("");

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = useCallback(async () => {

        // check if client exists
        const client = await axios.get(`${config.apiBaseUrl}/user/client/verify`, { withCredentials: true })
        console.log(client)
        if (client) {
            setNric(client.data.nric)
            setName(client.data.full_name)
            setAddress(client.data.block + client.data.street_name + client.data.postal_code)
            setFloor(client.data.floor)
            setUnit(client.data.unit)
            setResidentStatus(client.data.status)
            setCountry(client.data.country)
            setMobile(client.data.singpass_mobile)
            setExistingClient(client.data.id)
        }
        setTermsModal(true);
    }, [])

    // form validation
    const checkNric = useCallback(() => {
        if (nric[0] ? nric[0].toLowerCase() !== "s" && nric[0].toLowerCase() !== "t" && nric[0].toLowerCase() !== "g" : null) {
            setNricError("NRIC must start with 'S', 'T' or 'G' ")
        }
        else if (nric.length < 9) {
            setNricError("NRIC must have at least 9 characters")
        }
        else { setNricError("") }
    }, [nric])

    const checkName = useCallback(() => {
        if (name.length < 4) {
            setNameError("Name must have at least 4 characters")
        } else { setNameError("") }
    }, [name])

    const checkAddress = useCallback(() => {
        if (Object.keys(address) !== 0) {
            setAddressError("")
        }
    }, [address])

    const checkResident = useCallback((e) => {
        if (e) {
            setResidentError("")
        }
    }, [])

    const checkCountry = useCallback(() => {
        if (country) {
            setCountryError("")
        }
    }, [country])

    const checkMobile = useCallback(() => {
        if (mobile.length < 8) {
            setMobileError("Mobile cannot have less than 8 characters")
        } else { setMobileError("") }
    }, [mobile])


    const registerClient = useCallback(async () => {

        if (!nric || !name || Object.keys(address).length === 0 || !residentStatus || !country || !mobile) {
            if (!nric) {
                setNricError("NRIC is required")
            }
            if (!name) {
                setNameError("Name is required")
            }
            if (Object.keys(address).length === 0) {
                setAddressError("Address is required")
            }
            if (!residentStatus) {
                setResidentError("Resident Status is required")
            }
            if (!country) {
                setCountryError("Country is required")
            }
            if (!mobile) {
                setMobileError("Mobile Number is required")
            }
        }

        else if (nric && name && residentStatus && country && mobile &&
            !nricError && !nameError && !addressError && !residentError && !countryError && !mobileError) {

            const client = await axios.post(`${config.apiBaseUrl}/user/bid/registration`, {
                nric,
                name,
                address,
                floor,
                unit,
                residentStatus,
                country,
                mobile
            }, { withCredentials: true })

            const clientId = client.data.data
            // console.log("clientId", clientId)
            const bid_detail_id = props.id
            // console.log("bid_detail_id", bid_detail_id)
            const response = await axios.get(`${config.apiBaseUrl}/payment`, {
                params: {
                    clientId,
                    bid_detail_id
                }
            }, { withCredentials: true })
            // console.log("payment",response.data)
            // returning the stripe sessionID to generate the stripe payment page
            if (response.data) {
                const stripe = await loadStripe('pk_test_51MyCtHBtiThgr32facws8YyTI6103Ta080fqAtTTnKLutsH6YeMwI4kyop2wUj8FOGovASFXhXe6XUZpyqlSdJoY00gh0OejGW')
                stripe.redirectToCheckout({ sessionId: response.data });

            }
            // authData.updateIsClientAuth(true)
            console.log("submitted")
        }

    }, [address, country, floor, mobile, name, nric, residentStatus, unit, addressError, nameError, nricError, countryError, mobileError, residentError, props.id])

    const updateClient = useCallback(async () => {
        console.log("need to write the code for updating client")
    })

    const payment = useCallback(async () => {

        const clientId = exisitingClient
        const bid_detail_id = props.id

        const response = await axios.get(`${config.apiBaseUrl}/payment`, {
            params: {
                clientId,
                bid_detail_id
            }
        }, { withCredentials: true })

        if (response.data) {
            const stripe = await loadStripe('pk_test_51MyCtHBtiThgr32facws8YyTI6103Ta080fqAtTTnKLutsH6YeMwI4kyop2wUj8FOGovASFXhXe6XUZpyqlSdJoY00gh0OejGW')
            stripe.redirectToCheckout({ sessionId: response.data });

        }

        // authData.updateIsClientAuth(true)

        console.log("submitted")
    },[exisitingClient, props.id])

    return (
        <>
            <Button variant="danger" size="sm" onClick={handleShow}>
                Register to Bid
            </Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Register to Bid</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span onKeyUp={checkNric}>
                        <TextBlock label="NRIC" updateParentValue={(value) => (setNric(value))} value={nric} errorMessage={nricError} />
                    </span>
                    <span onKeyUp={checkName}>
                        <TextBlock label="Full Name (As Per NRIC)" updateParentValue={(value) => (setName(value))} value={name} errorMessage={nameError} />
                    </span>
                    <span onChange={checkAddress}>
                        <GetAddress label="NRIC Address" updateParentValue={(value) => (setAddress(value))} value={address} errorMessage={addressError} />
                    </span>
                    <span>
                        <TextBlock label="Floor" updateParentValue={(value) => (setFloor(value))} value={floor} />
                    </span>
                    <span>
                        <TextBlock label="Unit" updateParentValue={(value) => (setUnit(value))} value={unit} />
                    </span>
                    <span onChange={checkResident}>
                        <DropdownBlock label="Resident Status" updateParentValue={(value) => (setResidentStatus(value))}
                            option={options.map((d) => { return (d.residentStatus) })} value={residentStatus} errorMessage={residentError} />
                    </span>
                    <span onKeyUp={checkCountry}>
                        <TextBlock label="Country of Residence" updateParentValue={(value) => (setCountry(value))} value={country} errorMessage={countryError} />
                    </span>
                    <span onKeyUp={checkMobile}>
                        <TextBlock type="number" label="Mobile Number" updateParentValue={(value) => (setMobile(value))} value={mobile} errorMessage={mobileError} />
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    {exisitingClient ? <div><Button variant="danger" onClick={updateClient}>Update not ready</Button>
                        <Button variant="danger" onClick={payment}>Payment</Button> </div> :
                        <Button variant="danger" onClick={registerClient}>Submit</Button>}

                </Modal.Footer>
            </Modal>
            <CommonModal title="Terms & Conditions" message="Please take note that you will need to pay a deposit to bid at the end of the registration"
                footer={<button onClick={() => { setTermsModal(false); setShow(true) }}>I agree to the terms</button>} show={termsModal}
                handleClose={() => { setTermsModal(false); setShow(false); }} />

        </>
    )
}